import { render, staticRenderFns } from "./videoRightBtn.vue?vue&type=template&id=8f50b470&scoped=true&"
import script from "./videoRightBtn.vue?vue&type=script&lang=js&"
export * from "./videoRightBtn.vue?vue&type=script&lang=js&"
import style0 from "./videoRightBtn.vue?vue&type=style&index=0&id=8f50b470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50b470",
  null
  
)

export default component.exports